import { Link } from "react-router-dom";
import styles from "./Breadcrumb.module.css";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[] | null | undefined;
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  if (!items || items.length <= 1) return null;
  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      <ol className={styles.list}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.path || i} className={styles.item}>
              {i > 0 && <span className={styles.separator} aria-hidden="true">/</span>}
              {isLast || !item.path ? (
                <span className={styles.current} aria-current="page">{item.label}</span>
              ) : (
                <Link to={item.path} className={styles.link}>{item.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
